import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import scrollTo from 'scroll-to-element';
import R, { equals } from 'ramda';

class MarketingProfileReadiness extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMarketingReady: false,
      marketingReadyPercentage: 0,
      marketingReadinessErrors: [],
    };
  }

  componentWillReceiveProps(next) {
    if (next[`isMarketingReady`] !== this.props[`isMarketingReady`]) {
      // update internal state
      this.setState({
        isMarketingReady: next[`isMarketingReady`],
        marketingReadyPercentage: next[`marketingReadinessPercentage`],
        marketingReadinessErrors: next[`marketingReadinessErrors`],
      });
    }
  }

  getRouteToDisplay() {
    const { pathname } = this.props;
    if (pathname.indexOf('/profile/product') > -1) return 'Product';
    if (pathname.indexOf('/profile/locations') > -1) return 'Location';
    return 'Profile';
  }
  render() {
    const {
      isMarketingReady,
      marketingReadyPercentage,
      marketingReadinessErrors,
    } = this.props;

    let classes = 'marketing-readiness-div';
    let title;
    let errors;
    const routeToDisplay = this.getRouteToDisplay();
    const readinessContainerStyle = {
      position: 'relative',
      display: 'block',
      maxWidth: '100%',
      boxShadow: 'none',
      background: 'rgba(0,0,0,.03)',
      height: '48px',
      borderRadius: '2px 2px 0px 0px',
    };
    if (isMarketingReady && marketingReadyPercentage === 100) {
      title = `${routeToDisplay} Complete!`;
      classes += ' marketing-is-ready';
      if (routeToDisplay === 'Profile') {
        errors = (
          <div className="market-readiness-error-container l-paper-split-segment">
            <ul>
              <li> You are ready to <a className="profile-link-container-link" href={`${process.env.NEW_SYSTEM_URL}/partner-management/partner-list/partner?jwt=${localStorage.getItem('jwt')}`}>
                add partners
              </a>. </li>
              <li> You are ready for <Link className="profile-link-container-link" to="/contracting/contract-list/recent">Rates & Contracting</Link>. </li>
              <li> You are visible on <Link className="profile-link-container-link" to="/partner-finder/results">Partner Finder</Link>. </li>
            </ul>
          </div>
        );
      }
    } else {
      title = `${routeToDisplay}: ${marketingReadyPercentage}% Complete`;
      classes += ' marketing-is-not-ready';
      readinessContainerStyle.border = '1px solid rgba(39,41,43,.15)';
      readinessContainerStyle.borderBottom = '0px';
      errors = (
        <div className="market-readiness-error-container l-paper-split-segment">
          <ul>
            {(marketingReadinessErrors || []).map((error, index) => {
              return (
                <li
                  key={index}
                  onTouchTap={error.warning.includes('contact') ? () => {
                    const scrollToAnchor = () => {
                      const element = document.querySelector('#contactsNode');
                      if (element) scrollTo('#contactsNode', { offset: -70 });
                    };
                    scrollToAnchor();
                  } : error.scrollTo}
                  className="underline"
                  style={{ cursor: 'pointer', color: '#00bcd4' }}
                >
                  {error.warning}
                </li>
              );
            })}
          </ul>
        </div>
      );
    }

    const color = marketingReadyPercentage === 100 ? '#5bbd72' : '#f2c037';
    const textColor = marketingReadyPercentage === 100 ? 'white' : 'rgba(0, 0, 0, 0.870588)';
    return (
      <div
        className={classes}
        style={{ marginTop: '32px' }}
      >
        <div style={readinessContainerStyle} >
            <div
              style={{
                transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
                position: 'absolute',
                width: `${marketingReadyPercentage}%`,
                height: '100%',
                zIndex: '-1',
                backgroundColor: color,
                top: 0,
              }}
            >
              &nbsp;
            </div>
            <div
              style={{
                padding: '0 6px',
                textAlign: 'center',
                lineHeight: '48px',
                verticalAlign: 'middle',
                fontSize: '18px',
                color: textColor,
              }}
            >
              {title}
            </div>
          </div>
          {errors}
      </div>
    );
  }
}

MarketingProfileReadiness.propTypes = {
  isMarketingReady: PropTypes.bool,
  marketingReadinessErrors: PropTypes.array,
  marketingReadyPercentage: PropTypes.number,
  pathname: PropTypes.string,
  routeName: PropTypes.string,
  singleLoc: PropTypes.bool,
};

const select = ({ user, profile, profileLocation, profileProduct, routing }) => {
  const defaultMap = {
    pathname: routing.locationBeforeTransitions.pathname,
    singleLoc: (user.getIn(['company', 'oneOrMultiProperties']) === 'one-prop'),
  };
  if (defaultMap.pathname.indexOf('/profile/product') > -1) { // at a product
    const productId = defaultMap.pathname.split('/').pop().toString();
    return ({
      ...defaultMap,
      isMarketingReady: profileProduct.getIn([productId, 'isMarketingReady']),
      marketingReadyPercentage: profileProduct.getIn([productId, 'marketingReadinessPercentage']) || 0,
      marketingReadinessErrors: profileProduct.getIn([productId, 'marketingReadinessErrors']),
    });
  }
  if (defaultMap.singleLoc) {
    // single locations have two pages in one
    const locationId = profile.getIn(['locations', 0, 'id']);
    const filteredCompanyErrors = (profile.get('marketingReadinessErrors') || [])
      .filter(x => x.warning !== 'At least 1 complete location is required.'
        && x.warning !== 'At least 1 contact is required.');
    return ({
      ...defaultMap,
      isMarketingReady: profileLocation.getIn([locationId, 'isMarketingReady']) && profile.get('isMarketingReady'),
      marketingReadyPercentage: Math.min(
        profileLocation.getIn([locationId, 'marketingReadinessPercentage']) || 0,
        profile.get('marketingReadinessPercentage') || 0,
      ),
      marketingReadinessErrors: R.uniqBy(
        x => x.warning,
        (profileLocation.getIn([locationId, 'marketingReadinessErrors']) || [])
          .concat(filteredCompanyErrors)
      ),
    });
  }
  if (defaultMap.pathname.indexOf('/profile/locations') > -1) { // at a location
    const locationId = defaultMap.pathname.split('/').pop().toString();
    return ({
      ...defaultMap,
      isMarketingReady: profileLocation.getIn([locationId, 'isMarketingReady']),
      marketingReadyPercentage: profileLocation.getIn([locationId, 'marketingReadinessPercentage']) || 0,
      marketingReadinessErrors: profileLocation.getIn([locationId, 'marketingReadinessErrors']),
    });
  }
  return ({// general Profile
    ...defaultMap,
    isMarketingReady: profile.get('isMarketingReady'),
    marketingReadyPercentage: profile.get('marketingReadinessPercentage') || 0,
    marketingReadinessErrors: profile.get('marketingReadinessErrors'),
  });
};

export default connect(select, {})(MarketingProfileReadiness);



// WEBPACK FOOTER //
// ./src/app/components/profile/profile-left-bar/marketing-profile-readiness.jsx